export default __webpack_public_path__ + "dab0ebf17c4c46cff583b36d55f0da85.pdf";